$(document).ready(() => {
  if ($('.template-product').length > 0) {
    const plpUrl = document.referrer;

    if (window.history && plpUrl && plpUrl !== window.location.href) {
      $(window).on('popstate', function(event) {
        event.preventDefault(); // Stop default behavior
        history.back(); // Use browser history instead of reloading
      });
    }
  }
});

$(window).on('load', function() {
  if ($('.template-collection').length > 0) {
    var prevScroll = localStorage.getItem('prev-scroll');
    var prevUrl = localStorage.getItem('prev-url');

    if (prevScroll && prevUrl && window.location.href === prevUrl) {
      setTimeout(function() {
        window.scrollTo(0, parseInt(prevScroll, 10));
        localStorage.removeItem('prev-scroll');
        localStorage.removeItem('prev-url');
      }, 200);
    }

    function saveScrollPosition() {
      localStorage.setItem('prev-url', window.location.href);
      localStorage.setItem('prev-scroll', window.scrollY);
    }

    window.addEventListener('beforeunload', saveScrollPosition);
    window.addEventListener('pagehide', saveScrollPosition);
  }
});
